import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import Login from './layout/Login';
import Main from './layout/Main';
import { Toaster } from 'react-hot-toast';
import jwt_decode from "jwt-decode";

import './style/main.css';

const container = document.getElementById('root');
const root = createRoot(container);

let LST = localStorage.getItem('token');
if(LST){
  LST = jwt_decode(LST);
}



  const toastop = {
    style: {
        borderRadius: '10px',
        background: '#333',
        color: '#fff',
    },
    ariaProps: {
        role: 'status',
        'aria-live': 'polite',
    }
  };


  const requireAuth = () => {


  if( LST && LST.exp > Math.floor(new Date() / 1000) ) {


    return <>  <BrowserRouter> <Toaster position="top-center" toastOptions={toastop} />  <Main />  </BrowserRouter> </>
  }
  else  {

    localStorage.clear();

    return   <>  <BrowserRouter> <Toaster position="top-center" toastOptions={toastop} />  <Login /> </BrowserRouter>  </>


   }
  // stay on this route since the user is authenticated

}



root.render(requireAuth());

serviceWorker.register();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
